import app from 'app';
import templateUrl from './base.html';
import './base.scss';

function baseCtrl(
  $state,
  $location,
  $rootScope,
  Chat,
  GetCare,
  Posing,
  User,
  TimeService
) {
  const Base = this;

  /**
   * Don't show footer in Get Care after a search.
   * @return {[type]} [description]
   */
  Base.showFooter = () => !$state.is(GetCare.mapResults.stateName);

  Base.isGetCareMapResults = () => $state.is(GetCare.mapResults.stateName);

  Base.isPosing = Posing.isPosing;

  Base.is404 = () => $state.is('404');
  Base.isSafariOutage = () => $state.is('safariOutage');

  Base.showFive9Chat = () => $state.params.isChatOpen;

  Base.isChOpen = TimeService.isChOpen();
}

app.component('baseComponent', {
  controller: baseCtrl,
  controllerAs: 'Base',
  templateUrl,
});

export default 'baseComponent';
